// Bootstrap import: initializes i18next and resolves the stored/browser locale.
import './config';
import { setLanguage, getInitialLocale } from './config';

// Fire-and-forget bootstrap; react-i18next useSuspense:false renders with
// fallback/⚠keys until bundles land.
void setLanguage(getInitialLocale());

export * from './config';
